
  import NativeClient from "@/client/native-client";
  import { defineComponent, SetupContext, ref, toRefs, watch } from "vue";
  
  export default defineComponent({
    name: "ShoppingListEditMenu",
    props: {
      /** isShowMenu */
      isShowMenu: {
        type: Boolean,
        required: true
      },
      /** 食品IDの有無 */
      hasFoodId: {
        type: Boolean,
        required: true
      }
    },
    setup(props, context: SetupContext) {
      // FoodIdの判定
      const isValidFavorite = ref(true);
      const { hasFoodId } = toRefs(props);
      watch(hasFoodId, () => {
      NativeClient.sendDebugLog("ShoppingListEditMenu watch");
      if (hasFoodId.value && !isValidFavorite.value) {
        NativeClient.sendDebugLog("ShoppingListEditMenu watch to Favorite Valid");
        isValidFavorite.value = true;
      } else if (!hasFoodId.value && isValidFavorite.value) {
        NativeClient.sendDebugLog("ShoppingListEditMenu watch to Favorite no Valid");
        isValidFavorite.value = false;
      }
    });

      const deleteText = "リストから削除する";
      const appendText = "お気に入りに追加する";
      const cancelText = "キャンセル";
      const deleteClicked = () => {
        NativeClient.sendDebugLog("ShoppinglistEditMenu delete clicked");
        context.emit("delete-click");
      };
      const favoriteClicked = () => {
        NativeClient.sendDebugLog("ShoppinglistEditMenu favorite clicked");
        context.emit("favorite-click");
      };
      const cancelClicked = () => {
        NativeClient.sendDebugLog("ShoppinglistEditMenu cancel clicked");
        context.emit("cancel-click");
      };

      return {
        isValidFavorite,
        deleteText,
        appendText,
        cancelText,
        deleteClicked,
        favoriteClicked,
        cancelClicked
      };
    }
  });
  